// DownloadModal.js - Modal for entering filename when downloading Python code

import React from 'react';

const DownloadModal = ({ 
  downloadFilename, 
  setDownloadFilename, 
  onConfirm, 
  onClose 
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ 
        width: '400px', 
        maxWidth: '90%', 
        padding: '30px',
        textAlign: 'center'
      }}>
        <h2 style={{ marginBottom: '20px', color: '#00d4ff' }}>💾 Save Python File</h2>
        <p style={{ color: '#8b949e', marginBottom: '20px' }}>
          Enter a filename for your Python code:
        </p>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '25px' }}>
          <input
            type="text"
            value={downloadFilename}
            onChange={(e) => setDownloadFilename(e.target.value)}
            placeholder="Enter filename"
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') onConfirm();
              if (e.key === 'Escape') onClose();
            }}
            style={{
              flex: 1,
              padding: '12px 15px',
              fontSize: '16px',
              backgroundColor: '#2d333b',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '6px 0 0 6px',
              color: '#fff',
              outline: 'none'
            }}
          />
          <span style={{
            padding: '12px 15px',
            fontSize: '16px',
            backgroundColor: '#1e2227',
            border: '1px solid rgba(255,255,255,0.08)',
            borderLeft: 'none',
            borderRadius: '0 6px 6px 0',
            color: '#8b949e'
          }}>.py</span>
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 25px',
              backgroundColor: '#6b7280',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '10px 25px',
              backgroundColor: '#238636',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            ⬇️ Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
